// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { GetOperatorResponse } from '@digitalasset/utility-api-ts-client';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useUtilityOperatorApiClient } from '../../contexts/UtilityApiContext';

export const useUtilityOperatorParty = (): UseQueryResult<string, string> => {
  const utilityOperatorApi = useUtilityOperatorApiClient();

  return useQuery({
    queryKey: ['getOperator'],
    queryFn: async () =>
      utilityOperatorApi.getOperator().then((response: GetOperatorResponse) => response.partyId),
    refetchInterval: false,
  });
};
